export default __webpack_public_path__ + "static/media/radio_f.a3358c8a.svg";